import { useEffect } from "react";

const useFixFocusScroll = (fixedElementSelector, focusableSelector = "input, button, select, textarea") => {
    useEffect(() => {
        const fixedElement = document.querySelector(fixedElementSelector);
        if (!fixedElement) return;

        const fixedElementHeight = fixedElement.offsetHeight || 100;
        const offset = 50;

        const adjustScroll = (event) => {
            const elementRect = event.target.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            if (elementRect.bottom > viewportHeight - fixedElementHeight - offset) {
                window.scrollBy({
                    top: elementRect.bottom - (viewportHeight - fixedElementHeight - offset),
                    left: 0,
                    behavior: "smooth"
                });
            }
        };

        // Function to attach event listeners dynamically
        const attachListeners = () => {
            document.querySelectorAll(focusableSelector).forEach((el) => {
                el.removeEventListener("focus", adjustScroll); // Prevent duplicates
                el.addEventListener("focus", adjustScroll);
            });
        };

        attachListeners(); // Initial binding

        // Set up MutationObserver to detect new elements
        const observer = new MutationObserver(() => attachListeners());
        observer.observe(document.body, { childList: true, subtree: true });

        // Cleanup
        return () => {
            observer.disconnect();
            document.querySelectorAll(focusableSelector).forEach((el) => {
                el.removeEventListener("focus", adjustScroll);
            });
        };
    }, [fixedElementSelector, focusableSelector]); // Runs when dependencies change
};

export default useFixFocusScroll;
